import { useCallback, useId, useRef } from 'react';

/**
 * Client-only unique ids, based on React `useId()`.
 * The prefix is unique per component instance; the counter distinguishes
 * items added after mount (checkpoints, files, request tokens).
 */
export const useLocalId = () => {
  const prefix = useId();
  const n = useRef(0);

  return useCallback(() => {
    n.current += 1;
    return `${prefix}${n.current}`;
  }, [prefix]);
};

export default useLocalId;
